import {useRoute} from "vue-router";
import {computed} from "vue";

export default function useCurrentPage(lastPage) {
  const route = useRoute();

  return computed(() => {
    if (null === lastPage || undefined === route.query.page) {
      return 1;
    }

    const page = parseInt(route.query.page);

    if (isNaN(page) || page < 1) {
      return 1;
    }

    if (lastPage < page) {
      return lastPage;
    }

    return page;
  });
}